import React, { useState } from 'react';
import { Card, CardContent } from 'components/shadcn/ui/card';
import { Tabs, TabsList, TabsTrigger, TabsContent } from 'components/shadcn/ui/tabs';
import LogTable from './LogTable';
import StatusTable from './StatusTable';

const UpgradeLogDetails = () => {
    const [tab, setTab] = useState('log');

    return (
        <div>
            <Card>
                <CardContent className="pt-4">
                    <Tabs
                        value={tab}
                        onValueChange={setTab}
                        className="w-[95%] mx-auto mt-3"
                    >
                        <TabsList className="w-full justify-center">
                            <TabsTrigger value="log">Log</TabsTrigger>
                            <TabsTrigger value="status">Status</TabsTrigger>
                        </TabsList>
                        <TabsContent value="log">
                            <LogTable />
                        </TabsContent>
                        <TabsContent value="status">
                            <StatusTable />
                        </TabsContent>
                    </Tabs>
                </CardContent>
            </Card>
        </div>
    );
};

export default UpgradeLogDetails;
